var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCircleWavyCheckOutlineIcon = function SvgCircleWavyCheckOutlineIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M5.61 18.89c-.863-.862-.291-2.671-.732-3.73C4.438 14.1 2.75 13.171 2.75 12s1.669-2.062 2.128-3.16c.46-1.096-.131-2.868.731-3.73.863-.863 2.672-.291 3.732-.732C10.4 3.938 11.328 2.25 12.5 2.25s2.063 1.669 3.16 2.128 2.868-.131 3.73.731c.863.863.291 2.672.732 3.732.44 1.059 2.128 1.987 2.128 3.159s-1.669 2.063-2.128 3.16.131 2.868-.731 3.73c-.863.863-2.672.291-3.732.732-1.059.44-1.987 2.128-3.159 2.128s-2.062-1.669-3.16-2.128c-1.096-.46-2.868.131-3.73-.731"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    d: "M16.625 9.75 11.122 15l-2.747-2.625"
  })));
};
export default SvgCircleWavyCheckOutlineIcon;